// extracted by mini-css-extract-plugin
module.exports = {"absolute":"arrowAnchor_absolute__1kYg7","left":"arrowAnchor_left__3B5ls","right":"arrowAnchor_right__1QBSn"};